import {Patient} from "./patient.model";

export class TestOrder {
  PatientId: number;
  PatientName: string;
  PanelIds: Array<number>;
  SelectedPanels: Array<TestOrderPanel>;
  LocationId: number;
  LocationName: string;
  ReleaseOn?: string;
  ICDCodeIds: Array<number>;
  SelectedCodes: Array<ICDCode>;
  PhysicianId: string;
  PhysicianName: string;
  ReleaseYear?: string;
  ReleaseMonth?: string;
  ReleaseDay?: number;
  PatientDob?: string;
  TempPatient?: Patient;

  constructor() {
    this.PanelIds = [];
    this.SelectedPanels = [];
    this.ICDCodeIds = [];
    this.SelectedCodes = [];
    this.ReleaseYear = null;
    this.ReleaseMonth = null;
    this.ReleaseDay = null;
  }

  getPayload = () => {
    return {
      PatientId: this.PatientId,
      ICDCodes: this.ICDCodeIds,
      PanelIds: this.PanelIds,
      PhysicianId: this.PhysicianId,
      ReleasedOn: this.ReleaseOn,
      LocationId: this.LocationId
    };
  };
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/models/test-order.model.ts